import ComponentInitializer from '../libs/component-initializer';
import ComponentBase from './base/component-base';
import { EVENT_GLOBAL_UPDATE_CART } from '../constants/event';

class CartComponent extends ComponentBase {
  private cartUrl: string | null = null;
  protected updateCartBind: (() => Promise<void>) | null = null;
  //elements
  protected cartContent: HTMLElement | null = null;
  protected cartCheckoutButton: HTMLElement | null = null;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  protected init(): void {
    this.initialize();
    this.setup();
  }

  protected initialize(): void {
    this.cartUrl = this.element.dataset.cartUrl || '';
    this.updateCartBind = this.updateCart.bind(this);
    this.cartContent = this.element.querySelector('.j-cart-content');
    this.cartCheckoutButton = this.element.querySelector(
      '.j-cart-checkout-button'
    );
  }

  protected setup(): void {
    this.addEventListeners();
  }
  protected addEventListeners(): void {
    if (this.updateCartBind) {
      document.addEventListener(EVENT_GLOBAL_UPDATE_CART, this.updateCartBind);
    }
  }

  protected destroyEventListeners(): void {
    super.destroyEventListeners();
    if (this.updateCartBind) {
      document.removeEventListener(
        EVENT_GLOBAL_UPDATE_CART,
        this.updateCartBind
      );
    }
  }

  private async updateCart(): Promise<void> {
    if (!this.cartUrl) {
      return;
    }

    try {
      const response = await fetch(this.cartUrl, {
        headers: {
          Accept: 'text/html',
        },
      });

      if (!response.ok) {
        throw new Error('Cart fetch failed');
      }

      const html = await response.text();
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = html;

      // 新しいカートコンテンツを見つける
      const newCartContent = tempContainer.querySelector('.j-cart-content');
      if (newCartContent && this.cartContent) {
        // 既存のコンテンツを新しいコンテンツで置き換え
        this.cartContent.replaceWith(newCartContent);
        // this.cartContent参照を更新
        this.cartContent = newCartContent as HTMLElement;

        ComponentInitializer.fireUpdateViewEvent();
      }
    } catch (error) {
      console.error('Failed to update cart:', error);
    }
  }
}

ComponentInitializer.initializeComponent('.j-cart', CartComponent);
